import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import type { ITypeaheadOptions } from "../../../interfaces/i-typeahead";
import { ApplicationEnum, PendingReason, PendingReasonEnum } from "../../../enums/enums";
import { Template } from "../../../models/template";
import { TemplateService } from "../../../services/template-service";
import { enumToMap } from "../../../common/vue-helpers/modifiers/enum-modifiers";

import NewTypeahead from "../NewTypeahead/NewTypeahead.vue";

export default defineComponent({
    components: {
        NewTypeahead
    },
    props: {
        classList: { type: Object, default: { input: "w-75", textarea: "" } },
        showTemplateTypeahead: { type: Boolean, default: true },
        showTemplateDropdown: { type: Boolean, default: false },
        inputName: { type: String, default: "comments" },
        result: { type: String, default: "" },
        placeholder: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        maxLength: { type: Number, default: 65535 },
        application: { typeof: ApplicationEnum, default: null },
        commentRequired: { type: Boolean, default: false }
    },
    data() {
        return {
            selectedTemplate: null as ITypeaheadOptions,
            templates: [] as Template[],
            maxCharLimit: 65535,
            _templateService: null,
            patientPendingReasons: enumToMap(PendingReason),
            pendingReason: null
        };
    }
});
